import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";

/**
 * CRUD Service for PropensityScoringRun entity (F-029).
 * Provides standard CRUD operations for scoring run records.
 */
@Injectable({
    providedIn: 'root'
})
export class PropensityScoringRunService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/propensityScoringRuns')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-chart-line';
    }
}
